module.exports = __webpack_public_path__ + "img/coursedog-logo.103b306.png";